var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.displayItems.length)?_c('div',{staticClass:"institutional-logos-banner",class:_vm.variant},_vm._l((_vm.displayItems),function(logo,index){return _c('img',{key:`${logo.url}-${index}`,staticClass:"institutional-logo",attrs:{"src":logo.url,"alt":logo.alt}})}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }